// Version : 1.0.0
// Author : AGALYA

import PassportActionType from './passport-details.types';

/** ***************** Passport Update Start ************************/
export const updatePassportStart = (passportIdCredentials: any) => ({
	type: PassportActionType.UPDATE_PASSPORT_START,
	payload: passportIdCredentials,
});

export const updatePassportSuccess = (passportIdSuccess: any) => ({
	type: PassportActionType.UPDATE_PASSPORT_SUCCESS,
	payload: passportIdSuccess,
});

export const updatePassportFailure = (passportIdFailure: any) => ({
	type: PassportActionType.UPDATE_PASSPORT_FAILURE,
	payload: passportIdFailure,
});

export const updatePassportResponseResetStart = () => ({
	type: PassportActionType.UPDATE_PASSPORT_RESPONSE_REST_START,
});

export const updatePassportResponseChanged = () => ({
	type: PassportActionType.UPDATE_PASSPORT_RESPONSE_CHANGED,
});
/** ***************** Passport Update End ************************/
